module.exports = __webpack_public_path__ + "static/media/icon-header-menu.98116027.svg";